import { decode } from "html-entities";
/**
 * Group By
 * Groups a collection of objects based on key
 * @param {array} Collection
 * @param {function} Key getter
 * @returns {array} Collection grouped by key
 */ const groupBy = (list, fn)=>{
    const map = new Map();
    list.forEach((item)=>{
        const key = fn(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [
                item
            ]);
        } else {
            collection.push(item);
        }
    });
    return map;
};
/**
 * Group by type a collection of objects
 * @param {array} collection of objects
 * @return {set} grouped collection
 */ const groupByType = (collection)=>groupBy(collection.map((item, index)=>({
            ...item,
            text: decode(item.text),
            index
        })), (item)=>item.type);
/**
 * Collection by group
 * Transforms a collection into the same 2 dimensional grouped by types
 * @
 */ export const collectionByGroup = (collection)=>{
    if (!collection || collection.length < 1) return [];
    const grouped = groupByType(collection);
    return [
        ...grouped.keys()
    ].map((key)=>({
            key,
            suggestions: grouped.get(key)
        }));
};
export const boldText = (text, patron)=>{
    const regex = new RegExp(patron.replace(/[\\{()}]/g, ''), 'gi');
    return text.replaceAll(regex, (str)=>`<strong>${str}</strong>`);
};

//# sourceMappingURL=index.js.map